import * as React from 'react';

import { Body1, Button, Image, UIHeading2 } from '@cian/ui-kit';

import reload from '../../AiSummaryModalDesktop/assets/Reload1.svg';
import * as styles from './styles.css';

export interface IErrorMobileScreenProps {
  onReload: () => void;
}

export const ErrorMobileScreen = ({ onReload }: IErrorMobileScreenProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <Image src={reload} height={120} width={120} />
      <div className={styles['text-wrapper']}>
        <UIHeading2>Что-то пошло не так</UIHeading2>
        <Body1 textAlign="center">Проверьте интернет и попробуйте обновить</Body1>
      </div>
      <Button onClick={onReload} size="L" fullWidth={true}>
        Обновить
      </Button>
    </div>
  );
};
